function tokenizeQuery(query: string): string[] {
  return query.match(/\S*"[^"]*"\S*|\S+/g) ?? []
}

function addFilterToQuery(query: string | undefined, prefix: string, value: string): string {
  const filter = `${prefix}:${value}`

  if (!query) return filter

  const filterTerms = tokenizeQuery(query)
  const nonMatchingTerms = filterTerms.filter(term => !term.startsWith(`${prefix}:`))
  if (nonMatchingTerms.length === 0) return filter

  const newQuery = filterTerms.length === nonMatchingTerms.length ? query : nonMatchingTerms.join(' ')
  return `${newQuery} ${filter}`
}

export function addRepoFilterToQuery(query: string | undefined, repo: string): string {
  return addFilterToQuery(query, 'repo', repo)
}

export function addAuthorFilterToQuery(query: string | undefined, author: string): string {
  return addFilterToQuery(query, 'author', author)
}

export function addLabelFilterToQuery(query: string | undefined, label: string): string {
  const labelValue = label.includes(' ') ? `"${label}"` : label
  return addFilterToQuery(query, 'label', labelValue)
}

export function addAssigneeFilterToQuery(query: string | undefined, assignee: string): string {
  return addFilterToQuery(query, 'assignee', assignee)
}
